/* src/app/account/digital-wallet/components/terms-conditions-dialog/terms-conditions-dialog.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.dialog {
  width: 100%;
  padding: 24px 32px;
  flex-direction: column;
  align-items: flex-start;
  background: #FFF;
}
.dialog .headline-container {
  position: sticky;
  top: 0;
  width: 100%;
  background-color: #FFF;
}
.dialog .close {
  margin-top: 15px;
  display: flex;
  width: auto;
  justify-content: flex-end;
  align-items: flex-start;
  cursor: pointer;
}
.dialog .frame {
  display: flex;
  padding-bottom: 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  background: #FFF;
}
.dialog .frame .headline {
  margin-top: 10px;
  display: flex;
  padding-right: 0px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;
}
.dialog .frame .headline .headline-text {
  align-self: stretch;
  color: var(--ups-brand-colors-ups-black, #121212);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}
.dialog .frame .headline .keyline {
  width: 72px;
  height: 4px;
  background: var(--ups-brand-colors-ups-gold, #FFC400);
}
.dialog .text {
  margin-top: 30px;
  color: var(--ups-brand-colors-ups-black, #121212);
  leading-trim: both;
  text-edge: cap;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.dialog .text h4 {
  font-weight: 600;
}
.dialog .text ul {
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
}
/*# sourceMappingURL=terms-conditions-dialog.component.css.map */
